// F153 (Slack go-live thread, Eliška 2026-08-14): "Pro Empire by mělo v emailu
// být i Davidovo osobní číslo (skutečné číslo si ověř u Davida, zatím použij
// +420 774 253 021)."
//
// 🔴 PENDING: David has NOT confirmed this number. It is the placeholder from
// Eliška's message and it goes into a mail that reaches a paying Empire client,
// so it is the one string in this wave a human still has to sign off. Changing
// it is this one line: nothing else in the product knows the digits.
//
// It lives in `shared/` rather than in the locale files because it is one FACT
// in two languages, and a number that had to be kept identical in cs.json and
// en.json by hand is a number that will one day differ between them.

/**
 * 🔴 The separators are NO-BREAK spaces (U+00A0), written as escapes so a
 * reader can see them. Measured in a real browser at the mail's own width: with
 * ordinary spaces the English body wrapped the number across two lines as
 * "+420" / "774 253 021", which is the one fact this mail exists to carry,
 * broken in half and no longer copyable in one gesture. The F149 lesson (a word
 * breaking at its own hyphen in a narrow column), on a phone number.
 */
export const EMPIRE_PERSONAL_PHONE = "+420\u00A0774\u00A0253\u00A0021";

/**
 * True until David confirms the number above. The guard reads it, so the day it
 * flips to false somebody has to have looked at the digits.
 */
export const EMPIRE_PERSONAL_PHONE_PENDING_CONFIRMATION = true;
